<template>
  <div id="user-manage-detail-login-diary"
       class="mar-b-100">
    <!-- <div class="ipub-h2 line-h-40 relative mar-b-12">
      Login Diary
    </div> -->
    <div class="page-content-table">
      <ipub-table :columns="columns"
                  :pagination="pagination"
                  :dataSource="dataSource">
      </ipub-table>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
